import { assertNever } from "../../../types/index.ts";

export const ENTRA_ID_CALLER_APP_PERMISSIONS = [
  "Group.Read.All",
  "GroupMember.Read.All",
  "User.Read.All",
  "RoleManagement.Read.All",
  "Reports.Read.All",
  "AuditLog.Read.All",
] as const;

export type EntraIdPermission =
  (typeof ENTRA_ID_CALLER_APP_PERMISSIONS)[number];

/**
 * Maps Entra ID permission names to their corresponding Azure permission IDs.
 * These are hardcoded Azure IDs used by the "caller app" of the security perimeter.
 *
 * @see https://docs.microsoft.com/en-us/graph/permissions-reference
 */
export const toPermissionId = (permission: EntraIdPermission) => {
  switch (permission) {
    case "Group.Read.All":
      return "5b567255-7703-4780-807c-7be8301ae99b";
    case "GroupMember.Read.All":
      return "98830695-27a2-44f7-8c18-0c3ebc9698f6";
    case "User.Read.All":
      return "df021288-bdef-4463-88db-98f22de89214";
    case "RoleManagement.Read.All":
      return "c7fbd983-d9aa-4fa7-84b8-17382c103bc4";
    case "Reports.Read.All":
      return "230c1aed-a721-4c5d-9cb4-a90514e508ef";
    case "AuditLog.Read.All":
      return "b0afded3-3588-46d8-8b3d-9842eff778da";
    default:
      assertNever(permission);
  }
};

export const toPermissionDescription = (permission: EntraIdPermission) => {
  switch (permission) {
    case "Group.Read.All":
      return "Read all groups";
    case "GroupMember.Read.All":
      return "Read group memberships";
    case "User.Read.All":
      return "Read all users' full profiles";
    case "RoleManagement.Read.All":
      return "Read role management resources";
    case "Reports.Read.All":
      return "Read all usage reports";
    case "AuditLog.Read.All":
      return "Read all audit log data";
    default:
      assertNever(permission);
  }
};
